export const propertyReferralsInfo = [
  {
    title: "Social Media",
    percentage: 64,
    color: "#ff922b",
  },
  {
    title: "Marketplace",
    percentage: 56,
    color: "#40c057",
  },
  {
    title: "Websites",
    percentage: 50,
    color: "#fcc419",
  },
  {
    title: "Digital Ads",
    percentage: 80,
    color: "#5c7cfa",
  },
  {
    title: "Others",
    percentage: 15,
    color: "#f03e3e",
  },
];
